// LEXA (docs/DECISIONS.md, 2026-08-28 "LEXA - Phase 1") - thin service
// wrapper for Ask LEXA / Agent LEXA / feedback, mirroring studyPlan.js's
// apiFetch style (student-facing, not the admin call()/readErrorDetail
// pattern adminMentor.js uses).

import { apiFetch, LEXA_SERVICE_ORIGIN } from './api';

// payload: { conversationId?, message, question?, chapter?, concept?,
// difficulty?, studentAnswer?, correctAnswer? }
// -> { conversationId, messageId, response }
export async function askLexa(payload) {
  const response = await apiFetch(
    '/api/lexa/ask', { method: 'POST', body: JSON.stringify(payload) }, LEXA_SERVICE_ORIGIN
  );
  if (!response.ok) throw new Error('Ask LEXA is unavailable right now.');
  return response.json();
}

// payload: { conversationId?, message, page? } -> { conversationId, messageId, response }
export async function agentLexaSupport(payload) {
  const response = await apiFetch(
    '/api/lexa/support', { method: 'POST', body: JSON.stringify(payload) }, LEXA_SERVICE_ORIGIN
  );
  if (!response.ok) throw new Error('Agent LEXA is unavailable right now.');
  return response.json();
}

// payload: { conversationId, messageId, rating, feedbackText? } -> { recorded: true }
export async function submitLexaFeedback(payload) {
  const response = await apiFetch(
    '/api/lexa/feedback', { method: 'POST', body: JSON.stringify(payload) }, LEXA_SERVICE_ORIGIN
  );
  if (!response.ok) throw new Error('Failed to submit feedback.');
  return response.json();
}

// docs/DECISIONS.md, 2026-08-28 "LEXA - Phase 3" - creates a real ticket in
// the SAME support queue Support/Manager staff already triage from (not a
// separate LEXA-only system). payload: { conversationId, issueSummary,
// browserInfo? } -> { ticketId, status }
export async function escalateLexaSupportTicket(payload) {
  const response = await apiFetch(
    '/api/lexa/support/escalate', { method: 'POST', body: JSON.stringify(payload) }, LEXA_SERVICE_ORIGIN
  );
  if (!response.ok) throw new Error('Failed to create a support request.');
  return response.json();
}
